@if (form) {
  <form [formGroup]="form" class="flex flex-col gap-8 w-full overflow-hidden">
    <blaze-logical-query-row
      data-cy="ComplexFilter:RootLogicalQueryRow"
      formGroupName="query"
      [isInOrganizeMode]="isInOrganizeMode"
      [disabled]="disabled"
      [useAppTheme]="useAppTheme"
      [layout]="layout"
      (itemDrop)="onItemDrop($event)"
      (delete)="deleteRow($event)"
    />
  </form>
  <div
    class="pt-16 pb-8 pl-[68px] flex flex-row gap-8 items-center justify-between w-full"
    [class.column-layout]="columnLayout"
  >
    @if (!isInOrganizeMode && !disabled) {
      <div class="actions-container">
        <button
          type="button"
          class="btn btn-secondary"
          data-cy="ComplexFilter:AddNewFilterBtn"
          (click)="addNewRow(form)"
        >
          Add new
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          data-cy="ComplexFilter:OrganizeBtn"
          [disabled]="organizeBtnDisabled"
          blazeTooltip="Group and organize conditions"
          [matTooltipDisabled]="organizeBtnDisabled"
          [matTooltipShowDelay]="300"
          (click)="toggleOrganizeMode()"
        >
          Organize
        </button>
      </div>
      <div class="actions-container">
        <ng-content select="[complex-filters-buttons]" />
      </div>
    }
    @if (isInOrganizeMode && !disabled) {
      <div
        class="w-full flex"
        [ngClass]="{
          'gap-4': columnLayout,
          'flex-col': columnLayout,
          'gap-8': !columnLayout,
        }"
      >
        <div class="actions-container">
          <button
            type="button"
            class="btn btn-secondary"
            data-cy="ComplexFilter:GroupBtn"
            [disabled]="selectedFormGroups.length < 2"
            (click)="groupNodes()"
          >
            Group
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-cy="ComplexFilter:BreakBtn"
            [disabled]="
              selectedLogicalFormGroups.length === 0 ||
              selectedLogicalFormGroups.length !== selectedFormGroups.length
            "
            (click)="breakGroups()"
          >
            Break
          </button>
        </div>
        <span class="help-text"
          >Choose at least two filters to form a new group.<br />Drag to reorder or include in an
          existing group.</span
        >
        <span class="flex-1"></span>
        <div class="flex justify-end pl-4 ml-auto" [ngClass]="{ 'w-1/2': columnLayout }">
          <button type="button" class="btn btn-primary" (click)="toggleOrganizeMode()">
            Done
          </button>
        </div>
      </div>
    }
  </div>
}
